import 'codemirror/lib/codemirror.css';
var createSylCardDOM = function () {
    var div = document.createElement('div');
    div.setAttribute('__syl_tag', 'true');
    div.setAttribute('contenteditable', 'false');
    div.setAttribute('draggable', 'true');
    div.innerHTML = '<templ style="display: none"></templ><mask></mask>';
    return div;
};
var fixCodeString = function (code) {
    return code
        .replace(/&nbsp;/g, ' ')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};
var DEFAULT_LANGUAGE = 'javascript';
var transformToShow = function (iLanguage) {
    var language = iLanguage
        .split(/[-,]/)
        .filter(Boolean)
        .join('');
    if (language === 'js') {
        language = 'javascript';
    }
    return language;
};
var removeEmptyCodeBlock = function (view, code) {
    var state = view.state, dispatch = view.dispatch;
    var selection = state.selection;
    if (code.getValue().trim() || !selection.empty || selection.$from !== selection.$to) {
        return false;
    }
    var $pos = selection.$from;
    var parent = $pos.node();
    // confirm that pos is at the start of code_block
    if ($pos.start() !== $pos.pos || !parent.type.spec.code) {
        return false;
    }
    var type = !$pos.node(-1) && $pos.node(-1) !== state.schema.nodes.doc ? $pos.node(-1).type : state.schema.nodes.paragraph;
    var tr = state.tr.setNodeMarkup($pos.before(), type);
    dispatch(tr);
    return true;
};
export { createSylCardDOM, DEFAULT_LANGUAGE, fixCodeString, removeEmptyCodeBlock, transformToShow };
//# sourceMappingURL=utils.js.map